import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import moment from 'moment';
import VueQriously from 'vue-qriously';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.filter('truncate', (str: string, count: number = 10) => {
  if (!str) {
    return '';
  }
  if (str.length <= count) {
    return str;
  }
  return `${str.substring(0, count)}...`;
});

Vue.filter('dateFormatFromTimeStamp', (unixTime: number) => {
  return moment.unix(unixTime).format('YYYY/MM/DD HH:mm:ss');
});

Vue.filter('arrayToString', (array: string[]) => {
  let str = '';
  if (!array || array!.length === 0) {
    return str;
  }
  array!.forEach((a, index) => {
    str += a;
    if (index !== array.length - 1) {
      str += ', ';
    }
  });
  return str;
});

Vue.use(VueI18n);
Vue.use(Vuetify);
Vue.use(VueQriously);
Vue.use(VueClipboard);

const i18n = new VueI18n({
  locale: window.navigator.language.substr(0,2),
  fallbackLocale: 'en',
  messages: {
    en: require('./locales/en.json'),
    ja: require('./locales/ja.json'),
    uk: require('./locales/uk.json'),
  },
});

if (module.hot) {
  module.hot.accept(['./locales/en.json', './locales/ja.json', './locales/uk.json'], () => {
    i18n.setLocaleMessage('en', require('./locales/en.json').default);
    i18n.setLocaleMessage('ja', require('./locales/ja.json').default);
    i18n.setLocaleMessage('uk', require('./locales/uk.json').default);
    console.log('hot reload');
  });
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

export default i18n;
